import React, { createContext } from "react";
export const AxiomAppContext = createContext({});
